$(function () {

	// -----------------------------------------------------------
	// slick.js
	// -----------------------------------------------------------

	const $listItems = $('.list-items-other');

	$listItems.slick({
		autoplay: false,
		speed: 800,
		autoplaySpeed: 4000,
		variableWidth: true,
		infinite: true,
		dots: false,
		prevArrow: '<a class="btn-prev"></a>',
		nextArrow: '<a class="btn-next"></a>',
		appendArrows: $('.sec-items-other__nav'),
		autoplay: true,
        slidesToShow: 1,
        adaptiveHeight: true
});

});
